import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { AuthHttpService } from 'app/shared/auth-http.service'
import { Observable } from 'rxjs'
import { ICabinWire, ICabinDepartureSelection, ICabinSelection, ICabinGroup, ICabinDeparture, ICabin } from 'app/cabins/cabins.interfaces'
import { ResourceService } from 'app/shared/resources/resource.service';
import { SalesChannelService } from 'app/shared/salesChannel/sales-channel.service';
import { IFlowReservation } from 'app/shared/steps/step.model';
import { QuoteChanged, PriceSpecificationType, UserQuoteDetails, QuoteLine } from 'app/shared/quote/quote.events';
import { EnvironmentService } from 'app/environment.service';
import { toParamsObj } from '../shared/utils';

@Injectable()
export class CabinsService {

    constructor(private http: HttpClient, private authhttp: AuthHttpService, private resourceService: ResourceService, private salesChannelService: SalesChannelService, private environmentService: EnvironmentService) { }

    public getCabinsFlow(reservation: IFlowReservation): Observable<ICabinWire> {
        let params = {
            'salesOwner': this.resourceService.getSalesOwner(),
            'locale': this.resourceService.getLocale(),
            'salesChannel': this.salesChannelService.getCode(),
            'departureOut': reservation.outboundDepartureId,
            'product': reservation.productCode,
            'departureReturn': reservation.returnDepartureId,
            'adults': '' + reservation.adults,
            'children': '' + reservation.children
        }

        const url = `${this.environmentService.getSbServiceUrl()}/api/cabins-flow`
        return this.http.get<ICabinWire>(url, { params: toParamsObj(params) })
    }

    public getCabinsFromReservation(reservationCode: string): Observable<ICabinWire> {
        let params = { 'reservationCode': reservationCode }
        const url = `${this.environmentService.getSbServiceUrl()}/api/cabins-amendment/`
        return this.authhttp.get<ICabinWire>(url, { params: toParamsObj(params) })
    }

    public postHybridCabins(cabinSelections: ICabinDepartureSelection[]): Observable<any> {
        return this.http.post('/_mvc/booking/cabins-flow', cabinSelections)
    }

    public getQuoteModel(outboundSelections: ICabinSelection[], outboundOptions: ICabinDeparture, homeboundSelections: ICabinSelection[], homeboundOptions: ICabinDeparture): QuoteChanged {
        let outbound = this.buildUserQuoteDetails(outboundSelections, outboundOptions)
        let homebound = homeboundOptions && this.buildUserQuoteDetails(homeboundSelections, homeboundOptions)
        return new QuoteChanged(PriceSpecificationType.Cabins, outbound, homebound, null)
    }

    private buildUserQuoteDetails(selections: ICabinSelection[], options: ICabinDeparture) {
        let lines = selections.map(s => options.cabinGroups.flatMap<ICabinGroup, ICabin>(c => c.cabins).filter(f => f.id === s.id && +s.count !== 0).map(m => new QuoteLine(m.description, m.price.currentPrice, m.price.currencySymbol, s.count))).reduce((a, b) => a.concat(b), [])
        return new UserQuoteDetails(lines, null)
    }
}
